import { useState } from "react";

import { message } from "antd"; // Import message from antd

import useRequest from "./useRequest"; // Import useRequest hook
import { useNavigate } from "react-router";

const useAuth = () => {
  const { request } = useRequest(); // Destructure request from useRequest
  const navigate = useNavigate();

  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const getUser = () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  };

  const login = async (data) => {
    setLoading((prev) => ({ ...prev, post: true }));
    return await request(
      "post",
      "users/login/",
      (data) => {
        const accessToken = data.tokens.access;
        const refreshToken = data.tokens.refresh;

        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        message.success("Inicio de sesión exitoso"); // Show success message
        navigate("/excursiones");
        setLoading((prev) => ({ ...prev, post: false }));
      },
      (error) => {
        if (!error) {
          message.error("Error iniciando sesión, contáctate con el soporte");

          setLoading((prev) => ({ ...prev, post: false }));
          return;
        }

        error.status === 400
          ? message.warning(error.data.messageError)
          : message.error("Error iniciando sesión, contáctate con el soporte");

        setLoading((prev) => ({ ...prev, post: false }));
      },
      data
    );
  };

  return {
    login,
    getUser,
    loading,
    setLoading,
  };
};

export default useAuth;
